import apiService from 'apiService'
import React from 'react'
import { toast } from 'react-toastify'

export default function DisableUserIcon({ userId, refreshTable }) {
    const handleClick = async () => {
        const payload = {
            enabled: 0
        }
        await apiService.put(`/users/${userId}`, payload)
        refreshTable(+Date.now())
        toast.success('Επιτυχής απενεργοποίηση χρήστη!', {
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            theme: 'colored'
        })
    }

    return <i title="Απενεργοποίηση Χρήστη" className="fas fa-user-slash text-orange-500 mr-2" style={{ cursor: 'pointer' }} onClick={handleClick}></i>
}
